import { Component } from '@angular/core'
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-card-outer',
  templateUrl: './card-outer.component.html',
  styleUrl: './card-outer.component.scss'
})
export class CardOuterComponent {

}
